<template>
  <div align="center">
    <v-stepper non-linear="true">
      <v-stepper-header>
        <v-stepper-step complete step="1">
          Dados Cadastrais e Consumo
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step complete editable step="2"
          >Geração de Proposta</v-stepper-step
        >

        <v-divider></v-divider>

        <v-stepper-step step="3"> Escolha do Plano </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4"> Assinatura de Contrato </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="5"> Descontos </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <br />
    <h1>Estamos quase lá</h1>
    <br />
    <span
      >Agora nosso time está analisando sua conta de energia e gerando uma
      proposta especial para você.</span
    >
  </div>
</template>
<script>
export default {
  name: "Proposta",
};
</script>
<style scope></style>
